<template>
  <div class="applicant-item">
    <div class="applicant-avatar" :style="getApplicantAvatarStyle(applicant)"></div>
    <div class="applicant-content">
      <div class="applicant-basic-info">
        <div class="applicant-name-and-identity">
          <div class="applicant-name">{{applicant.applicant_name}}</div>
          <div class="applicant-identity">{{applicant.identity}}</div>
          <div class="aplicant-handle-btn">
            <div class="hide-box">
              <div v-if="!isUniversalIdentity" class="applicant-handle-change-identity" @click="openEditIdentity">
                <div class="icon"></div>修改身份
              </div>
              <div class="applicant-handle-delete" @click="$emit('applicantDelete', applicant.order_applicant_id)" v-if="order.applicant.length > 1 && !isOtaOnline">
                <div class="icon"></div>删除
              </div>
            </div>
            
            <!-- 只有第一个申请人才显示 -->
            <base-popover-with-close
              v-if="isFirst"
              position="top-right"
              storage-key="showed-ordering-upload-applicant-share"
              content="一键分享给顾客上传资料，上上签不会向顾客展示品牌及价格信息"
              width="214px"
            >
              <div class="applicant-share-btn" @click="shareModalShow = true">
                <div class="icon"></div>分享给顾客
              </div>
            </base-popover-with-close>
            <div class="applicant-share-btn" v-else @click="shareModalShow = true">
              <div class="icon"></div>分享给顾客
            </div>
          </div>
        </div>
        <div class="applicant-progress">
          <div class="applicant-progress-done" :style="{width: passPercent + '%'}">
            <div class="applicant-progress-num" :class="{'is-left': passPercent < 5}">{{passPercent}}%</div>
          </div>
        </div>
      </div>
      <div class="applicant-material">
        <div class="material-item">
          <div class="material-item-label">电子资料</div>
          <div class="material-item-status" v-if="materialTotal !== passMaterialTotal">还有 {{materialTotal - passMaterialTotal}} 项未完成</div>
          <div class="material-item-status done" v-else>已完成</div>
          <div class="material-item-btn">
            <router-link :to="{ name: 'upload', params: { oid: order.user_order_id, aid: applicant.order_applicant_id } }" class="jump-btn active" :class="{'done': materialTotal === passMaterialTotal}">{{materialTotal === passMaterialTotal ? '修改' : '去上传'}}</router-link>
          </div>
        </div>
        <div class="material-item" v-if="applicant.application">
          <div class="material-item-label">申请表</div>
          <div class="material-item-status done" v-if="applicant.application.application_status !== 1">已完成</div>
          <div class="material-item-status" v-else>未完成</div>
          <div class="material-item-btn">
            <router-link :to="{ name: 'apply', params: { oid: order.user_order_id, aid: applicant.order_applicant_id } }" class="jump-btn" :class="{'active': materialTotal === passMaterialTotal, 'done': applicationTotal === passApplicationTotal}">{{applicationTotal === passApplicationTotal ? '修改' : '去填写'}}</router-link>
          </div>
        </div>
      </div>
    </div>
    <edit-identity
      v-model="showEditIdentityModal"
      :productData="productData"
      :applicantId="applicant.order_applicant_id+''"
      :checkedIdentityId="applicant.identity_id+''"
      @updateApplicant="updateApplicant"
      ></edit-identity>

    <!-- 分享给顾客 -->
    <common-share-wxa-dialog
      :visible.sync="shareModalShow"
      title="分享给顾客"
      page="subpackage-order/pages/apply/ordering/customer-upload/customer-upload"
      :scene="`o=${order.user_order_id}&a=${applicant.order_applicant_id}`"
      methods-one-title="分享二维码给客户"
      :step-one-desc="applicant.applicant_name + '的' + order.country + '签证资料'"
      step-two-title="客户填写资料上传"
      step-two-img="https://o.666visa.cn/static/ssqpeer/product/created-order/share-applicant-img.png"
      methods-two-tips="复制链接并发送给客户，客户可在微信上直接打开上传资料"
      page-from="订单上传页"
    ></common-share-wxa-dialog>
  </div>
</template>
<script>
import orderingService from '../../../services/ordering-service';
import applicationFormService from '../../../services/application-form-service';
import editIdentity from '../modals/edit-identity-modal';
import BasePopoverWithClose from '../../../components/common/popover/base-popover-with-close.vue';
import CommonShareWxaDialog from '../../../components/common/share/common-share-wxa-dialog.vue';

export default {
  name: 'ordering-upload-applicant-item',
  components: {
    editIdentity,
    BasePopoverWithClose,
    CommonShareWxaDialog,
  },
  props: {
    order: Object,
    applicant: Object,
    productData: Object,
    isFirst: Boolean,
  },
  data() {
    return {
      fields: null, // 申请表字段信息
      showEditIdentityModal: false, // 修改身份弹窗
      shareModalShow: false,
    };
  },
  watch: {
    applicant: {
      handler(applicant) {
        // 当前申请人需要申请表
        if (applicant && applicant.application) {
          // 获取国家
          applicationFormService.getApplicationFields(applicant.application.application_url).then((data) => {
            this.fields = data;
          });
        }
      },
      immediate: true,
    },
  },
  computed: {
    // 是否是飞猪线上订单
    isOtaOnline() {
      let isOtaOnline = false;
      if (this.order.ota_info && !this.order.ota_info.ota_offline) {
        isOtaOnline = true;
      }
      return isOtaOnline;
    },
    // 申请人资料总数
    materialTotal() {
      if (!this.applicant) return 0;
      let sum = 0;
      // 拿到必须资料中的在线上传资料
      const material_required = this.applicant.material.material_required.filter(item => item.attr === 0);
      sum += material_required.length;
      // 有照片加一
      if (this.applicant.id_photo) {
        sum += 1;
      }
      return sum;
    },
    // 申请人通过的资料总数
    passMaterialTotal() {
      if (!this.applicant) return 0;
      let passSum = 0;
      // 拿到必须资料中的在线上传资料
      const material_required = this.applicant.material.material_required.filter(item => item.attr === 0);
      material_required.forEach((item) => {
        // 必须要上传过且为在线上传资料
        if (item.upload && item.upload.length) {
          // 身份证
          if (item.pattern === 1) {
            if (item.upload.length === 1) {
              // 选择没有身份证，
              if (item.upload[0].elec_status === 2 && item.upload[0].special_code) {
                passSum += 1;
              }
            } else if (item.upload.length === 2) {
              // 有身份证，则两张都需要上传
              if (item.upload.every(upload => upload.elec_status === 2)) {
                passSum += 1;
              }
            }
          } else if (item.upload[0].elec_status === 2) {
            // 除开身份证
            passSum += 1;
          }
        }
      });
      if (this.applicant.id_photo && this.applicant.id_photo.id_photo_status !== 1) {
        passSum += 1;
      }
      return passSum;
    },
    // 申请表组的总数
    applicationTotal() {
      if (!this.fields) return 0;
      // 加一是申请表的签名也占一项
      return this.fields.length + 1;
    },
    // 申请表已保存的组的总数
    passApplicationTotal() {
      if (!this.fields) return 0;
      if (this.applicant.application.application_status === 2) {
        // 如果申请表的状态已经是已提交，说明申请表已经提交了，不再计算
        return this.applicationTotal;
      }
      let sum = 0;
      const applicationData = this.applicant.application.content;
      this.fields.forEach((group) => {
        if (applicationData && (applicationData[group.name] === true || applicationData[group.name] === 1)) {
          // 组的数据存在，就说明该组已经填写完成
          sum += 1;
        }
      });
      // 签名存在
      if (this.applicant.application.signature) {
        sum += 1;
      }
      return sum;
    },
    // 申请人百分比
    passPercent() {
      let percent = 0;
      // 在线资料
      if (this.materialTotal) {
        percent = (this.passMaterialTotal / this.materialTotal) * 100;
      }
      if (this.applicant && this.applicant.application) {
        // 需要申请表
        percent += this.applicationTotal ? (this.passApplicationTotal / this.applicationTotal) * 100 : 0;
        // 需要申请表，百分比需要除以二，一个占百分之五十
        percent /= 2;
      }
      return parseInt(percent, 10);
    },
    // 通用身份判断
    isUniversalIdentity() {
      if (this.productData && this.productData.material && this.productData.material[0]) {
        return this.productData.material[0].identity_id === 5;
      }
      return false;
    },
  },
  methods: {
    getApplicantAvatarStyle: orderingService.getApplicantAvatarStyle,
    openEditIdentity() {
      this.showEditIdentityModal = true;
    },
    updateApplicant() {
      this.$emit('updateApplicant');
    },
  },
};
</script>
<style lang="less" scoped>
.applicant-item{
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 20px 20px 6px 20px;
  display: flex;
  margin-bottom: 20px;
  &:hover{
    .aplicant-handle-btn{
      .hide-box{
        display: flex !important;
      }
    }
  }
  .applicant-avatar{
    width: 56px;
    height: 56px;
    flex-grow: 0;
    flex-shrink: 0;
    background-size: 100% 100%;
    margin-right: 20px;
  }
  .applicant-content{
    flex-grow: 1;
    flex-shrink: 1;
    line-height: 1;
    .applicant-basic-info{
      color: #333;
      font-size: 18px;
      .applicant-name-and-identity{
        display: flex;
        align-items: flex-end;
        margin-bottom: 15px;
        .applicant-name{
          max-width: 400px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .applicant-identity{
          margin-left: 10px;
          white-space: nowrap;
          font-size: 14px;
          color: #aaa;
          flex-grow: 1;
        }
        .aplicant-handle-btn{
          flex-grow: 0;
          flex-shrink: 0;
          font-size: 14px;
          color: #666666;
          display: flex;
          align-items: center;
          .hide-box{
            display: flex;
            align-items: center;
            display: none;
            .applicant-handle-change-identity{
              cursor: pointer;
              display: flex;
              align-items: center;
              .icon{
                width: 17px;
                height: 17px;
                background: url('../../../assets/imgs/order/icon-update.png');
                background-size: 100%;
                margin-right: 5px;
              }
              &:hover{
                color: #5E9BE1;
                .icon{
                  background: url('../../../assets/imgs/order/icon-update-active.png');
                  background-size: 100%;
                }
              }
            }
            .applicant-handle-delete{
              display: none;
              cursor: pointer;
              display: flex;
              align-items: center;
              margin-left: 20px;
              .icon{
                width: 17px;
                height: 17px;
                background: url('../../../assets/imgs/order/icon-delete.png');
                background-size: 100%;
                margin-right: 5px;
              }
              &:hover{
                color: #5E9BE1;
                .icon{
                  background: url('../../../assets/imgs/order/icon-delete-active.png');
                  background-size: 100%;
                }
              }
            }
          }
          
          .applicant-share-btn{
            cursor: pointer;
            display: flex;
            align-items: center;
            margin-left: 20px;
            color: #5E9BE1;
            .icon{
              width: 16px;
              height: 16px;
              background: url('https://o.666visa.cn/static/ssqpeer/product/created-order/icon-applicant-share.png') no-repeat center / 100% 100%;
              margin-right: 4px;
            }
          }
        }
      }
      .applicant-progress{
        width: 100%;
        background: #f0f0f0;
        height: 4px;
        margin-bottom: 20px;
        position: relative;
        border-radius: 2px;
        .applicant-progress-done{
          position: absolute;
          left: 0;
          top: 0;
          height: 100%;
          border-radius: 2px;
          background:linear-gradient(90deg,rgba(110,188,255,1), rgba(94,155,225,1));
          .applicant-progress-num{
            position: absolute;
            top: 100%;
            right: 0;
            margin-top: 3px;
            font-size: 12px;
            color: #5E9BE1;
            line-height: 1;
            opacity:0.8;
            &.is-left{
              left: 0;
              right: auto;
            }
          }
        }
      }
    }

    .applicant-material{
      .material-item{
        padding: 14px 0;
        color: #333;
        font-size: 16px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #f0f0f0;
        &:last-child{
          border-bottom: none;
        }
        .material-item-label{
          width: 70px;
          margin-right: 15px;
        }
        .material-item-status{
          flex-grow: 1;
          color: #5E9BE1;
          font-size: 14px;
          &.done{
            color: #999999;
          }
        }
        .material-item-btn{
          height: 34px;
          .jump-btn{
            display: inline-block;
            padding: 9px 20px;
            font-size: 14px;
            line-height: 1;
            background: #fff;
            color: #5E9BE1;
            border: 1px solid #5E9BE1;
            border-radius: 4px;
            cursor: pointer;
            &.active{
              background: #5E9BE1;
              color: #fff;
            }
            &.done{
              border: 1px solid #CFCFCF;
              color: #777777;
              background: #fff;
            }
          }
        }
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/ordering-upload-applicant-item.vue